import templatePreview from "../../assets/whereby.png";
let wherebyImg = window.wpmNotificationPluginBuildUrl + templatePreview;
const downloadId = "602";

const whereby = [
  {
    id: "whereby_wp-signup-admin",
    image: wherebyImg,
    label: "Whereby",
    category: "wp-signup-admin",
    downloadId,
  },
  {
    id: "whereby_wp-signup-user",
    image: wherebyImg,
    label: "Whereby",
    category: "wp-signup-user",
    downloadId,
  },
  {
    id: "whereby_wp-lost-password-admin",
    image: wherebyImg,
    label: "Whereby",
    category: "wp-lost-password-admin",
    downloadId,
  },
  {
    id: "whereby_wp-lost-password-user",
    image: wherebyImg,
    label: "Whereby",
    category: "wp-lost-password-user",
    downloadId,
  },
  {
    id: "whereby_wp-password-changed-user",
    image: wherebyImg,
    label: "Whereby",
    category: "wp-password-changed-user",
    downloadId,
  },
  {
    id: "whereby_wp-change-user-email-user",
    image: wherebyImg,
    label: "Whereby",
    category: "wp-change-user-email-user",
    downloadId,
  },
  {
    id: "whereby_wp-changed-user-email-user",
    image: wherebyImg,
    label: "Whereby",
    category: "wp-changed-user-email-user",
    downloadId,
  },
  {
    id: "whereby_wp-comment-in-moderation-admin",
    image: wherebyImg,
    label: "Whereby",
    category: "wp-comment-in-moderation-admin",
    downloadId,
  },
  {
    id: "whereby_wp-comment-published-post-author",
    image: wherebyImg,
    label: "Whereby",
    category: "wp-comment-published-post-author",
    downloadId,
  },
  {
    id: "whereby_wp-change-site-admin-email",
    image: wherebyImg,
    label: "Whereby",
    category: "wp-change-site-admin-email",
    downloadId,
  },
  {
    id: "whereby_wp-changed-site-admin-email",
    image: wherebyImg,
    label: "Whereby",
    category: "wp-changed-site-admin-email",
    downloadId,
  },
  {
    id: "whereby_wp-request-personal-data-user",
    image: wherebyImg,
    label: "Whereby",
    category: "wp-request-personal-data-user",
    downloadId,
  },
  {
    id: "whereby_wp-confirmed-personal-data-request-admin",
    image: wherebyImg,
    label: "Whereby",
    category: "wp-confirmed-personal-data-request-admin",
    downloadId,
  },
  {
    id: "whereby_wp-download-personal-data-user",
    image: wherebyImg,
    label: "Whereby",
    category: "wp-download-personal-data-user",
    downloadId,
  },
  {
    id: "whereby_wp-erased-personal-data-user",
    image: wherebyImg,
    label: "Whereby",
    category: "wp-erased-personal-data-user",
    downloadId,
  },
];

export default whereby;
